<template>
    <div class="p-4 lg:p-8">
        <div class="surface-card p-4 shadow-sm border border-iron rounded-lg">

            <div class="mb-6">
                <h2 class="text-2xl font-bold text-secondary">Meus Materiais Exclusivos</h2>
                <p class="text-sm text-gray-500">
                    {{ translate('Below are the files, handouts, and media released for your learning', 'ucfirst') }}.
                </p>
            </div>

            <DataTable :value="materials" :loading="loading" dataKey="id" :paginator="true" :rows="10"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                responsiveLayout="stack" breakpoint="960px" class="p-datatable-sm shadow-sm border border-iron rounded">
                <template #empty>
                    {{ translate('no exclusive material has been released to you yet.', 'ucfirst') }}.
                </template>

                <Column field="name" :header="translate('name', 'ucfirst')" sortable class="font-semibold text-secondary" />

                <Column field="description" header="Descrição">
                    <template #body="slotProps">
                        <span class="text-sm text-gray-600 line-clamp-2">
                            {{ slotProps.data.description || translate('no description available.', 'ucfirst') }}
                        </span>
                    </template>
                </Column>

                <Column :header="translate('file', 'ucfirst')" class="text-center w-48">
                    <template #body="slotProps">
                        <Button label="Baixar Arquivo" icon="pi pi-download"
                            class="bg-purple-suit-forced border-none p-button-sm text-xs px-3"
                            :loading="downloadingIds.has(slotProps.data.id)" @click="downloadFile(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { useToast } from 'primevue';
import { showToast } from '@/composables/toast';
import MaterialService from '@/services/MaterialService';
import { useAuthStore } from '@/stores/auth';
import urlHandler from '@/composables/urlHandler';
import { translate } from '@/composables/translate';

const toast = useToast();
const auth = useAuthStore();
const student = ref(null);

const materials = ref([]);
const loading = ref(false);
const downloadingIds = ref(new Set());

onMounted(() => {
    if (!auth.getUser.hasStudent()) {
        showToast(toast, translate('not allowed', 'ucfirst'), 'error');
        urlHandler('/dashboard/');
        return;
    }

    student.value = auth.getUser.student;
    loadStudentMaterials();
});

/**
 * Busca apenas os materiais vinculados ao aluno autenticado
 */
const loadStudentMaterials = async () => {
    loading.value = true;
    materials.value = await MaterialService.getStudentMaterials(student.value.id) || [];
    loading.value = false;
};

/**
 * Faz a requisição do stream binário (Blob) e força o download seguro no navegador
 */
const downloadFile = async (material) => {
    const response = await MaterialService.fetchDonwloadData(material.id);

    if (!response.success()) {
        showToast(toast, response.getMessage(), 'error');
        return;
    }

    const url = window.URL.createObjectURL(new Blob([response.getContent()]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', material.name + material.getExtension());
    document.body.appendChild(link);
    link.click();
    link.remove();
};
</script>